export default "__VITE_ASSET__Bt_JaAV___"